import React from 'react';
import useReveal from '../hooks/use-reveal';

const STEPS = [
  {
    num: '1',
    title: 'Leave your name',
    body:
      "Just your first name and email. If something stirred when you read this, you can share what made you stop — but only if you want to.",
  },
  {
    num: '2',
    title: 'A few gentle messages',
    body:
      "Five short emails arrive over five days. One each morning. Quiet, honest, easy to read with a coffee — enough for you to feel whether this is something for you.",
  },
  {
    num: '3',
    title: 'The 30 days are yours',
    body:
      "Nothing is being launched. The whole process is already here, waiting. Start when you're ready and move at the pace that feels right — even if that's slow, even if you pause.",
  },
  {
    num: '4',
    title: 'Share what feels true',
    body:
      "If a moment lands or a sentence opens something up, share it with #unmaskyourvoice. Every voice that shares makes it a little safer for the next person to do the same.",
  },
];

const HowItWorks = () => {
  const head = useReveal();
  const steps = useReveal();

  return (
    <section
      data-testid="what-happens-next-section"
      style={{ padding: '100px 24px', maxWidth: '900px', margin: '0 auto' }}
    >
      <div ref={head.ref} className={`reveal ${head.visible ? 'visible' : ''}`}>
        <div className="yup-eyebrow" style={{ marginBottom: '20px' }}>
          What happens when you say yes
        </div>
        <h2 className="yup-section-title" style={{ marginBottom: '24px' }}>
          Gently.<br />
          <em>In your own time.</em>
        </h2>
      </div>

      <div
        ref={steps.ref}
        className={`reveal ${steps.visible ? 'visible' : ''}`}
        style={{ display: 'flex', flexDirection: 'column', marginTop: '48px' }}
      >
        {STEPS.map((s, i) => (
          <div
            key={s.num}
            data-testid={`next-step-${s.num}`}
            style={{
              display: 'flex',
              gap: '24px',
              padding: '28px 0',
              borderBottom: i === STEPS.length - 1 ? 'none' : '1px solid var(--yup-border)',
              alignItems: 'flex-start',
            }}
          >
            <div
              className="font-serif"
              style={{
                fontSize: '36px',
                fontWeight: 300,
                color: 'var(--yup-border)',
                lineHeight: 1,
                flexShrink: 0,
                width: '36px',
              }}
            >
              {s.num}
            </div>
            <div>
              <h4
                style={{
                  fontSize: '14px',
                  fontWeight: 500,
                  color: 'var(--yup-ink)',
                  marginBottom: '6px',
                  letterSpacing: '0.3px',
                }}
              >
                {s.title}
              </h4>
              <p style={{ fontSize: '14px', color: 'var(--yup-muted)', lineHeight: 1.6 }}>
                {s.body}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HowItWorks;
